import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import imgAcioneOne from '../../assets/logo/logo_acione_one.svg'
import eyeIcon from '../../assets/icons/eye_icon.svg'
import { useIsMutating } from "@tanstack/react-query";
import { Loader } from "../../components/generics/loader";

interface LoginProps {
  versao: string
}

export function Login({ versao }: LoginProps) {
  const [values, setValues] = useState({
    email: '',
    password: ''
  });
  // const [erro, setError] = useState("");
  const [isPasswordEnable, setIsPasswordEnable] = useState(false)
  const navigate = useNavigate();


  const handleValue = (event: ChangeEvent<HTMLInputElement>) => {
    setValues(prev => ({ ...prev, [event.target.name]: event.target.value }))
  }

  const { isAuthenticated, Login: handleLogin, cookies, error } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/home");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, cookies?.token]);

  async function goToInicial(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    const login = await handleLogin({ login: values.email, password: values.password });
    if (login === "Usuário ou senha incorretos") {
      e.preventDefault();
      // setError(login);
    } else {
      navigate(login);
    }
  }

  function goToResetPassword() {
    navigate("/reset-password")
  }

  const isFetching = useIsMutating({ mutationKey: ['login'] })
  return (
    <>
      <section className="bg-primary h-screen w-full">
        <div className=" flex h-full  items-center justify-between   -mt-10">
          <div className="w-[60%] flex  justify-center">
            <img src={imgAcioneOne} alt=""
              className="h-[70%] w-[70%]"
            />
          </div>

          <div className=" bg-white w-[80%] h-[150%] rounded-tl-full rounded-bl-full flex items-center justify-center">
            <div className="flex flex-col items-center justify-center">
              <h3 className="font-bold text-primary text-2xl">Acessar</h3>
              <div className="mt-1 text-error">{error}</div>
              <form
                className="flex flex-col items-center"

              >
                <div className="input-block">
                  <p className="input-p">Usuário:</p>
                  <input
                    type="text"
                    className="input-container"
                    name="email"
                    value={values.email}
                    onChange={handleValue}
                  />
                </div>
                <div className="input-block">
                  <p className="input-p">Senha:</p>
                  <div className="flex items-center input-container p-0 ">
                    <input
                      className="input-container  border-none "
                      type={isPasswordEnable ? "text" : "password"}
                      name="password"
                      value={values.password}
                      onChange={handleValue}
                    />
                    <button type="button" className="bg-transparent mr-2" onClick={() => setIsPasswordEnable(!isPasswordEnable)}>
                      <img src={eyeIcon} alt="" className="h-6 w-6 " />
                    </button>
                  </div>

                </div>
                <button
                  type="button"
                  className="mt-8 p-2 w-[100%] rounded-lg border-0 bg-primary "
                  onClick={e => goToInicial(e)}
                >
                  <p className="text-md font-normal uppercase text-white">
                    Entrar
                  </p>
                </button>
              </form>
              { /*  <button onClick={goToResetPassword}>
                <p className="text-primary py-4 hover:underline w-[25rem] text-left ">Esqueceu a senha?</p>
              </button> */}
            </div>
          </div>
        </div>
        {(isFetching) && (<div className=" flex justify-center top-0 items-center h-full w-full absolute bg-white opacity-70 z-50 px-4 py-4  ">
          <Loader size={4} />
        </div>)}

        <p className="text-white text-sm bottom-0 right-1/2 absolute" >Versão {versao}</p>
      </section>
    </>
  );
}
